export default class CoreIcons
{
    public static Confirmation = 'im im-question';
    public static Authentication = 'im im-enter';
}